import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizContainer } = framework_tool
const { isType } = utils_tool
import 'antd/dist/antd.css';
import {Button} from 'antd';
import moment from "moment";
import { WizTableForm } from '@/containers/common';
let {WizForm,WizSpin,WizSelect, WizRow,WizCol, WizIcon, WizTooltip,WizTimePicker,WizDatePicker } = component_tool;
const userConfig = WizTableForm.Config.user(this, {apiParams: {status: 1, roleConfig: "teacherNevRole"}});
const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
class NevAuthEditor extends WizContainer {
  componentName = 'nevAuthEditor'

  constructor(props) {
    super(props)
    this.state = {
      timestamp: new Date().getTime(),
      selectedRows: [],
      ids: [],
    };
    this.record={};
  }

  _componentWillMount() {
    const {record={} } = this.props;
    this.record=record;
  }


  _ok = (data) => {
    const { record={}} = this.props;
    let idList = [];
    const {remoteAuthId,classAideId,aideStartTime,aideEndTime} = record;
    let fitterValues = {};
    let authDateStr = '';
    let authStartTimeStr = '';
    let authEndTimeStr = '';
    Object.keys(data).forEach(key => {
      const value = data[key];
      if (key === 'authDate' && value != null && value != undefined) {
        fitterValues['authDate'] = value.format("YYYY-MM-DD HH:mm:ss");
        authDateStr = formatterDate(value);
      } else if (key === 'startDate' && value != null && value != undefined) {
        fitterValues['startDate'] = value.format("YYYY-MM-DD HH:mm:ss");
        authStartTimeStr = formatterTime(value);
      } else if (key === 'endDate' && value != null && value != undefined) {
        fitterValues['endDate'] = value.format("YYYY-MM-DD HH:mm:ss");
        authEndTimeStr = formatterTime(value);
      } else if (key === 'lectureId' && value != null && value != undefined) {
        let lectureIdList = [value];
        fitterValues['lectureIdList'] = lectureIdList;
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    if (authDateStr==='' || authStartTimeStr==='' || authEndTimeStr===''){
      wizNotice.error("请选择认证时间");
      return ;
    }
    let classDateStartTime_ = moment(aideStartTime).format('YYYY-MM-DD HH:mm:ss'); // 环节时间
    let classDateEndTime_ = moment(aideEndTime).format('YYYY-MM-DD HH:mm:ss'); // 环节时间
    let startDateTime_ = moment(authDateStr + ' ' + authStartTimeStr).format('YYYY-MM-DD HH:mm:ss'); // 认证时间
    fitterValues['startDate'] = startDateTime_;
    let endDateTime_ = moment(authDateStr + ' ' + authEndTimeStr).format('YYYY-MM-DD HH:mm:ss'); // 认证时间
    fitterValues['endDate'] = endDateTime_;
    let classDateStartTime = new Date(classDateStartTime_).getTime();
    let classDateEndTime = new Date(classDateEndTime_).getTime();
    let startDateTime = new Date(startDateTime_).getTime();
    let endDateTime = new Date(endDateTime_).getTime();
    log.info('fitterValues',fitterValues);
    if( startDateTime > endDateTime){
      wizNotice.error("认证结束时间不可早于开始时间,请确认后重试!");
      return ;
    }else if(startDateTime<=endDateTime && (endDateTime-startDateTime)<300000){
      wizNotice.error("认证时间间隔不可少于5分钟,请确认后重试!");
      return ;
    }else if(classDateStartTime>startDateTime){
      wizNotice.error("认证开始时间不可早于环节开始时间,请确认后重试!");
      return ;
    }else if(classDateEndTime && classDateEndTime<endDateTime){
      wizNotice.error("认证结束时间不可晚于环节结束时间,请确认后重试!");
      return ;
    }
    if (record && record.id ) {
      const {id} = record;
      idList.push(id);
    }else {
      wizNotice.error("请选择NEV认证详情");
      return ;
    }
    if (idList.length === 0){
      wizNotice.error("请选择NEV认证详情");
      return ;
    }else {
      this.doAction({
        path: 'nevRemoteAuthDetail/batchConfigNevRemoteAuthDetail',
        payload: {
          key: 'nevRemoteAuthDetail@batchConfigNevRemoteAuthDetail',
          apiParams: {...fitterValues,ids:idList,remoteAuthId:remoteAuthId,classAideId:classAideId}
        }
      })
    }
  }

  propsAndStateOnChange = {
    save: this._saveOnChange.bind(this)
  }

  _saveOnChange(nextProps, nextState) {
    if (nextProps.save.code === 1) {
      wizNotice.success('操作成功')
      this.props.changeModal(false, true);
      let { editorSuccess } = this.props
      editorSuccess && editorSuccess()
    } else {
      wizNotice.error(nextProps.save.msg);
    }
  }
  /**
   * 初始化已选人员
   */
  _doInitParams = () => {
    this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields();
  };


  /**
   * 禁用不能选择的日期
   * @param authValue
   * @returns {boolean}
   */
  disabledAuthDate = authValue => {
    let { aideStartTime,aideEndTime} = this.record;

    if (!aideStartTime || !aideEndTime) {
      return false;
    }
    let classDateStartStr = moment(aideStartTime).format('YYYY-MM-DD') + ' 00:00:00';
    let classDateEndStr = moment(aideEndTime).format('YYYY-MM-DD') + ' 23:59:59';
    return authValue.valueOf() > moment(classDateEndStr).valueOf() || authValue.valueOf() < moment(classDateStartStr).valueOf();
  };

  setAuthColumns = (record) => {
    let personInfo = [];
    if (record && record.lectureId && (record.lectureFullName || record.lectureName )){
      let lectureName = record.lectureFullName ? record.lectureFullName : record.lectureUserName;
      personInfo = [{key:'1',personId:record.lectureId, fullName:lectureName ,id:record.lectureId}]
    }
    return [
      {
        title: "账号",
        name: "userName",
        formItem: {
          initialValue: record.userName,
          disabled: true
        }
      },
      {
        title: "姓名",
        name: "fullName",
        formItem: {
          initialValue: record.fullName,
          disabled: true
        }
      },
      {
        title: "讲师",
        name: "lectureId",
        formItem: {
          ...userConfig,
          diy: WizTableForm,
          initialValue: record.lectureId!=null ? record.lectureId : '',
          initRows: personInfo,
          selectType: 'radio',
          rules: [{required: true, message: '请选择讲师'}],
        },
      },
      {
        title: "认证日期",
        formItem: {
          type: 'custom',
          render: (data, form) => {
            const {getFieldDecorator} = form;
            return (
              <div>
                {
                  getFieldDecorator('authDate', {
                    rules: [{required: true, message: '请选择认证日期',}],
                    initialValue: record && record.authDate ? moment(record && record.authDate) : record && record.aideStartTime ? moment(record.aideStartTime): undefined
                  })(
                    <WizDatePicker key='authDate'
                                   format="YYYY-MM-DD"
                                   disabledDate={this.disabledAuthDate}
                                   placeholder={'请选择认证日期'}
                    />
                  )
                }
              </div>
            )
          }
        }
      },
      {
        title: '认证时间',
        formItem: {
          type: 'custom',
          col: { span: 12 },
          formItemLayout: {
            labelCol: {span: 12},
            wrapperCol: {span: 12}
          },
          render: (data, form) => {
            const {getFieldDecorator} = form;
            return (
              <>
                <WizRow className={'credit-subject-row-item'}>
                  <WizCol span={24}>
                    {
                      getFieldDecorator('startDate', {
                        rules: [{required: true,message:"认证开始时间不可为空"}],
                        initialValue: record && record['startDate'] ? moment(record['startDate']) : record && record.aideStartTime ? moment(record.aideStartTime) : undefined
                      })(
                        <WizTimePicker placeholder={'请选择认证开始时间'}
                        />
                      )
                    }
                  </WizCol>
                </WizRow>
              </>
            )
          }
        }
      },
      {
        formItem: {
          type: 'custom',
          col: { span: 9 },
          formItemLayout: {
            labelCol: {span: 0},
            wrapperCol: {span: 24}
          },
          render: (data, form) => {
            const {getFieldDecorator} = form;
            return (
              <>
                <WizRow className={'credit-subject-row-item'}>
                  <WizCol className='col-item-center' span={6}>{'至'}</WizCol>
                  <WizCol span={18}>
                    {
                      getFieldDecorator('endDate', {
                        rules: [{required: true,message:"认证结束时间不可为空"}],
                        initialValue: record && record['endDate'] ? moment(record['endDate']) : record && record.aideEndTime ? moment(record.aideEndTime) : undefined
                      })(
                        <WizTimePicker
                          placeholder={'请选择认证结束时间'}
                        />
                      )
                    }
                  </WizCol>
                </WizRow>
              </>
            )
          }
        }
      },
    ];
  }

  render() {
    const {record={},nevRemoteAuthDetailLoading} = this.props
    const columns = this.setAuthColumns(record);
    const formProps = {
      key: this.state.timestamp,
      ref: 'form',
      columns,
      record:null,
      preview: false,
      onSubmit: this._ok,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 15 }
      }
    }

    return (
      <WizSpin tip={''} spinning={nevRemoteAuthDetailLoading}>
        <WizForm {...formProps} />
      </WizSpin>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  const { nevRemoteAuthDetail } = state
  const save = modelUtils.getModelEntity(nevRemoteAuthDetail, 'nevRemoteAuthDetail@batchConfigNevRemoteAuthDetail')
  const load = modelUtils.getLoadingState(state, ['nevRemoteAuthDetail']);
  return {
    save,
    ...load
  }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(NevAuthEditor)
